import dayjs from 'dayjs'
import XLSX from 'xlsx-js-style' 
import { editDateForExcel } from '@/utils/excel'

export const ExportExcel = async (jsonData: any[]) => {
    console.log('jsonData', jsonData)
    const reportExcel = jsonData.map(x => {
        let n = {} as any
        n[`ยูนิต`]                            = x.unitCode 
        n[`PJ Plan Date`]                   = x.planPJDate == "" ? "" : editDateForExcel(dayjs(x.planPJDate).format("DD/MM/YYYY"))
        n[`ครั้งที่`]                           = x.insNumber
        n[`สถานะการเก็บงาน`]                 = x.finishPJStatus
        n[`วันที่ CR นัดได้	`]                   = x.planCRDate == "" ? "" : editDateForExcel(dayjs(x.planCRDate).format("DD/MM/YYYY"))
        n[`เวลาที่นัดได้`]                      = x.planCRTime
        n[`ชื่อบริษัทรับตรวจบ้าน`]                = x.inspectorName
        n[`วันโอนกรรมสิทธิ์จริง`]            = x.transferDate == "" ? "" : editDateForExcel(dayjs(x.transferDate).format("DD/MM/YYYY"))
        n[`ชื่อลูกค้า`]                         = x.customerName
        n[`เบอร์โทรศัพท์ลูกค้า`]                 = x.mobilePhone
        n[`บ้านเลขที่`]                        = x.address
        n[`CR Name`]                        = x.crName
        n[`วันที่ PJ Plan ให้ CR ออกจดหมาย1`]   = x.letterDate == "" ? "" : editDateForExcel(dayjs(x.letterDate).format("DD/MM/YYYY"))
        n[`CR Note`]                        = x.crNote
        n[`PJ Note`]                        = x.pjNote
        return n
    })

    console.log('reportExcel', reportExcel)

    const dataWS = XLSX.utils.json_to_sheet(reportExcel,  {dateNF: "dd/MM/yyyy" })
        const wb = XLSX.utils.book_new()
            

        let nCols = 1
        for (const key in reportExcel) {
            nCols++
            dataWS[`B${nCols}`].t = "n"
            dataWS[`B${nCols}`].z = "dd/MM/yyyy"
            dataWS[`E${nCols}`].t = "n"
            dataWS[`E${nCols}`].z = "dd/MM/yyyy"
            dataWS[`H${nCols}`].t = "n"
            dataWS[`H${nCols}`].z = "dd/MM/yyyy"
            dataWS[`G${nCols}`].t = "n"
            dataWS[`G${nCols}`].z = "dd/MM/yyyy"
        }

        let wscols = [ 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:25 },
            { wch:25 }, 
            { wch:40 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:35 },
            { wch:40 },
            { wch:40 }
        ];
        dataWS['!cols'] = wscols
                
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb,`Report-${splitProjectCode(jsonData[0].unitCode)}-${dayjs().format("DD-MM-YYYY")}.xlsx`)
}

const splitProjectCode = (data: string) => {
    if (data != "") {
        const [ project, unit ] = data.split("-")
        return `${project}`
    }
    return ""
}